import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Form, Row, Col, Collapse } from 'react-bootstrap';
import { FaPlus, FaTrash, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridAreasProjeto = ({ codigoFamilia, areasProjeto, permissoes, onRecarregar }) => {
  const [aberto, setAberto] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [ativoSelected, setAtivoSelected] = useState(null);
  const [ativosOptions, setAtivosOptions] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!showForm) return;
    setCarregando(true);
    api.listarAtivosLookup(codigoFamilia)
      .then((res) => {
        const dados = res.data != null ? res.data : res;
        const opts = (Array.isArray(dados) ? dados : []).map((a) => ({
          value: a.codigo,
          label: a.codigo + ' - ' + a.descricao,
        }));
        setAtivosOptions(opts);
      })
      .catch(() => toast.error('Erro ao carregar ativos'))
      .finally(() => setCarregando(false));
  }, [showForm, codigoFamilia]);

  const handleIncluir = async () => {
    if (ativoSelected == null) {
      toast.error('Selecione um ativo.');
      return;
    }
    setSalvando(true);
    try {
      await api.incluirAreaProjetoConfig({
        codigo_familia: codigoFamilia,
        codigo_ativo: ativoSelected.value,
      });
      toast.success('Área incluída no projeto!');
      setShowForm(false);
      setAtivoSelected(null);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir área';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm('Excluir o ativo "' + item.nome + '" do projeto?')) return;
    try {
      await api.excluirAreaProjetoConfig({
        codigo_familia: codigoFamilia,
        codigo_ativo: item.codigo_ativo,
      });
      toast.success('Área removida do projeto!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir área';
      toast.error(msg);
    }
  };

  const lista = areasProjeto != null ? areasProjeto : [];

  return (
    <Card className="mb-3">
      <Card.Header
        className="d-flex justify-content-between align-items-center py-2"
        style={{ cursor: 'pointer' }}
        onClick={() => setAberto(!aberto)}
      >
        <strong>
          {aberto ? <FaChevronDown size={12} className="mr-2" /> : <FaChevronRight size={12} className="mr-2" />}
          Áreas do Projeto
        </strong>
        <span className="text-muted small">{lista.length} área(s)</span>
      </Card.Header>
      <Collapse in={aberto}>
        <Card.Body className="p-0">
          <div className="p-2">
            {permissoes.projeto && !showForm && (
              <Button size="sm" variant="outline-success" className="mb-2" onClick={() => setShowForm(true)}>
                <FaPlus className="mr-1" /> Incluir Área
              </Button>
            )}
            {showForm && (
              <div className="p-3 mb-2 border rounded bg-light">
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Ativo *</Form.Label>
                      <Select
                        options={ativosOptions}
                        value={ativoSelected}
                        onChange={setAtivoSelected}
                        placeholder={carregando ? 'Carregando...' : 'Selecione ativo...'}
                        isDisabled={carregando}
                        isClearable
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                      <FaPlus className="mr-1" /> Incluir
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => { setShowForm(false); setAtivoSelected(null); }} disabled={salvando}>
                      Cancelar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            <Table striped bordered hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: 100 }}>Código</th>
                  <th>Nome</th>
                  {permissoes.projeto && <th style={{ width: 60 }}>Ação</th>}
                </tr>
              </thead>
              <tbody>
                {lista.length === 0 && (
                  <tr>
                    <td colSpan={permissoes.projeto ? 3 : 2} className="text-center text-muted">Nenhuma área vinculada</td>
                  </tr>
                )}
                {lista.map((item) => (
                  <tr key={'area-' + item.codigo_ativo}>
                    <td>{item.codigo_ativo}</td>
                    <td>{item.nome}</td>
                    {permissoes.projeto && (
                      <td>
                        <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                          <FaTrash />
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            </div>
          </div>
        </Card.Body>
      </Collapse>
    </Card>
  );
};

export default GridAreasProjeto;
